import React from 'react';
import ReferralServicesForm from 'pages/components/ReferralServicesForm';

const ReferralNewServicesForm = (props) => (
  <ReferralServicesForm {...props} />
);

export default ReferralNewServicesForm;
